import { Box, HStack, Icon, Link, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiExternalLink, FiLink } from "react-icons/fi";
import { getMyOpenVotes, OpenVoteItem } from "@lubbezposrednio-frontend/core";

/** Jawne głosy zalogowanego wyborcy zakotwiczone on-chain (per pytanie) + link do eksploratora.
 *  Sam się chowa, gdy brak (tajne / nie zagłosował / niezalogowany / jeszcze niezakotwiczone). */
export const OnChainVotes: React.FC<{ votingId: string }> = ({ votingId }) => {
  const [items, setItems] = useState<OpenVoteItem[]>([]);

  useEffect(() => {
    let active = true;
    getMyOpenVotes(votingId)
      .then(r => active && setItems(r.data.open_votes || []))
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [votingId]);

  if (!items.length) return null;

  return (
    <Box w="100%" maxW="720px" mx="auto" px={{ base: "16px", md: "20px" }} pt="16px">
      <Box bg="white" border="1px solid rgba(67,0,152,0.10)" borderRadius="16px" boxShadow="0 6px 20px rgba(67,0,152,0.05)" p={{ base: "16px", md: "20px" }}>
        <HStack spacing="9px" mb="6px">
          <Icon as={FiLink} color="primary" boxSize="18px" />
          <Text fontWeight="800" color="primary">
            Twój głos na blockchainie
          </Text>
        </HStack>
        <Text fontSize="13px" color="gray.500" mb="14px">
          Każda Twoja odpowiedź została zakotwiczona pojedynczo on-chain — możesz ją niezależnie zweryfikować w eksploratorze.
        </Text>
        <VStack align="stretch" spacing="10px">
          {items.map(it => (
            <Box key={it.txid} border="1px solid rgba(67,0,152,0.08)" borderRadius="12px" p="12px 14px">
              {it.question && (
                <Text fontSize="12px" color="gray.500" mb="3px" noOfLines={2}>
                  {it.question}
                </Text>
              )}
              <HStack justify="space-between" align="center" gap="10px">
                <Text fontWeight="700" color="gray.700" noOfLines={1}>
                  {it.answer || "—"}
                </Text>
                {it.explorer_url && (
                  <Link href={it.explorer_url} isExternal color="primary" fontWeight="700" fontSize="13px" flexShrink={0}>
                    <HStack spacing="4px">
                      <Text>Eksplorer</Text>
                      <Icon as={FiExternalLink} boxSize="13px" />
                    </HStack>
                  </Link>
                )}
              </HStack>
              <Text fontFamily="mono" fontSize="11px" color="gray.400" mt="4px" noOfLines={1}>
                {it.txid}
              </Text>
            </Box>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};
